module.exports = __webpack_public_path__ + "img/FGr_Logistik_Führungstrupp.3528893e.svg";